<template>
    <div class="col-12">
        <h4 class="header-title m-t-0">
            <i class="fas fa-flag mr-1"/>
            <span v-html="$t('CarrierDestinationList.carrierDestinations')"/>
        </h4>
        <hr/>
        <v-client-table :data="carrier.destinations" :columns="table.columns" :options="table.options">
            <button @click="showCarrierDestinationModal()" class="btn btn-primary pull-right" slot="afterLimit">
                <i class="fa fa-plus-circle mr-1"/>
                <span v-html="$t('CarrierDestinationList.addCarrierDestination')"/>
            </button>
            <router-link class="font-bold" slot="country.name" slot-scope="props" :to="`/billing/carrier-destination/${props.row.id}`">
                <img class="shadow mr-1" width="30" alt="flag" :src="getDiceBaseUrl() + props.row.country.flagURL"/>
                <span v-html="props.row.country.name"/>
            </router-link>
            <span slot="area" slot-scope="props">
                <span v-if="!props.row.area.id" v-html="$t('CarrierDestinationList.noArea')"/>
                <router-link v-else :to="`/billing/carrier-area/${props.row.area.id}`" class="font-bold" v-html="props.row.area.name"/>
            </span>
            <BooleanIcon slot-scope="props" slot="enabledForApi" :boolean="props.row.enabledForApi"/>
            <span slot="margin" slot-scope="props" v-html="props.row.marginLabel()"/>
            <span slot="minDeliveryDays" slot-scope="props" v-html="props.row.minDeliveryDaysLabel()"/>
            <span slot="maxDeliveryDays" slot-scope="props" v-html="props.row.maxDeliveryDaysLabel()"/>
            <span slot="fixedTaxPercent" slot-scope="props" v-html="props.row.fixedTaxPercentLabel()"/>
            <div class="text-center" slot="actions" slot-scope="props">
                <router-link v-tooltip="$t('CarrierDestinationList.see')" :to="`/billing/carrier-destination/${props.row.id}`"
                        class="btn btn-info btn-xs mr-1">
                    <i class="fa fa-eye"/>
                </router-link>
                <button v-tooltip="$t('CarrierDestinationList.edit')" @click="showCarrierDestinationModal(props.row)"
                        class="btn btn-warning btn-xs mr-1">
                    <i class="fa fa-edit"/>
                </button>
                <CarrierDestinationDeleteButton :carrier-destination="props.row" v-tooltip="$t('CarrierDestinationList.delete')"
                                                @deleteCarrierDestination="deleteCarrierDestination"/>
            </div>
        </v-client-table>
        <CarrierDestinationFormModal @addCarrierDestination="addCarrierDestination" @editCarrierDestination="editCarrierDestination"
                                     @editCarrierArea="editCarrierArea" ref="CarrierDestinationFormModal"
                                     :carrier="carrier"/>
    </div>
</template>

<script>
import CarrierDestinationFormModal from "../../../../shared/Billing/CarrierDestination/CarrierDestinationFormModal";
import CarrierDestinationDeleteButton from "./CarrierDestinationDeleteButton";
import BooleanIcon from "@/components/shared/misc/BooleanIcon";
import {permissiveFilter} from "../../../../../helpers/VueTable";
export default {
    name: "CarrierDestinationList",
    components: { CarrierDestinationDeleteButton, CarrierDestinationFormModal, BooleanIcon },
    props: {
        carrier: {
            type: Object,
            required: true,
        },
    },
    // eslint-disable-next-line max-lines-per-function
    data() {
        return {
            table: {
                columns: ["country.name", "area", "enabledForApi", "margin", "minDeliveryDays", "maxDeliveryDays", "fixedTaxPercent", "actions"],
                options: {
                    perPage: 10,
                    sortable: ["country.name", "area", "enabledForApi", "margin", "minDeliveryDays", "maxDeliveryDays", "fixedTaxPercent"],
                    headings: {
                        "country.name": this.$t("CarrierDestinationList.country"),
                        area: this.$t("CarrierDestinationList.area"),
                        enabledForApi: this.$t("CarrierDestinationList.enabledForApi"),
                        margin: this.$t("CarrierDestinationList.margin"),
                        minDeliveryDays: this.$t("CarrierDestinationList.minDeliveryDays"),
                        maxDeliveryDays: this.$t("CarrierDestinationList.maxDeliveryDays"),
                        fixedTaxPercent: this.$t("CarrierDestinationList.fixedTaxPercent"),
                        actions: this.$t("CarrierDestinationList.actions"),
                    },
                    orderBy: {
                        column: "country.name",
                    },
                    filterAlgorithm: {
                        "country.name": (row, query) => permissiveFilter(row.country.name, query),
                        area: (row, query) => permissiveFilter(row.area.name, query),
                    },
                },
            },
        };
    },
    methods: {
        showCarrierDestinationModal(carrierDestination = null) {
            this.$refs.CarrierDestinationFormModal.show(carrierDestination);
        },
        addCarrierDestination(carrierDestination) {
            this.$emit("addCarrierDestination", carrierDestination);
        },
        editCarrierDestination(newCarrierDestination) {
            this.$emit("editCarrierDestination", newCarrierDestination);
        },
        deleteCarrierDestination(carrierDestination) {
            this.$emit("deleteCarrierDestination", carrierDestination);
        },
        editCarrierArea(area) {
            this.$emit("editCarrierArea", area);
        },
        getDiceBaseUrl() {
            return this.$diceAPI.getBaseUrl();
        },
    },
};
</script>

<style scoped>

</style>